<template>
<div>
    <h2>
    Privacy Policy for "Just Match 3" app.
    </h2>
    
<p>
    1. The application collects and stores data such as IP address, 
    approximate location of the device (based on IP address), 
    how the user interacts with the application (clicked ads, displayed ads).
</p>
<p>
    2. The collected data is transferred and shared with third-party companies in order to better match ads (contextual ad display).
</p>
<p>
    3. Data is stored for 30 days, in some cases up to 180 days.
</p>
<p>4. The user can disable contextual ads and delete data collected by the ad display system by clicking the settings on the displayed ad.
</p>
</div>
</template>
<!--
    Polityka prywatności dla aplikacji "Just Match 3".

Aplikacja zbiera i przechowuje dane takie jak adres IP, przybliżona lokalizacja urządzenia (na podstawie dresu IP), sposób interakcji użytkownika z aplikacją (klikane reklamy, wyświetlane reklamy).

Zbierane dane są przesyłane i udostępniane firmom zewnętrznym w celu lepszego dopasowania reklam (kontekstowe wyświetlanie reklam).

Dane są przechowywane przez okres 30 dni, w niektórych przypadkach do 180 dni.

Użytkownik może wyłączyć reklamy kontekstowe oraz usunąć dane zebrane przez system wyświetlania reklam poprzez kliknięcie ustawień na wyświetlanej reklamie.
-->

<script>

export default {
  name: 'download',
  components: {      
  },  
  methods: {
      $tr: function(x) { return x; }
  },
  data: function() {
      return {
          
      }
  }
}
</script>